import { createElement, type ReactNode } from 'react';

/**
 * Escape special regex characters in a string
 */
export function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Highlight matching search terms in text
 * Returns ReactNode array with <mark> elements around matches
 */
export function highlightMatches(
  text: string | null | undefined,
  queries: string[]
): ReactNode {
  if (!text || queries.length === 0) {
    return text ?? '';
  }

  const sanitizedQueries = queries
    .filter(Boolean)
    .map((query) => escapeRegExp(query.trim()))
    .filter(Boolean);

  if (sanitizedQueries.length === 0) {
    return text;
  }

  const pattern = new RegExp(`(${sanitizedQueries.join('|')})`, 'gi');
  const segments = text.split(pattern);

  return segments.map((segment, index) =>
    index % 2 === 1
      ? createElement(
          'mark',
          {
            key: `highlight-${index}`,
            className:
              'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/60 dark:text-emerald-200 rounded px-0.5',
          },
          segment
        )
      : createElement('span', { key: `text-${index}` }, segment)
  );
}
